'use client';

import Skeleton from '@carvana/ds-skeleton';
import { useCreditApplicationUpdate } from '~/context/flp-rsc/CreditApplicationUpdateContext';
import { usePricingUpdate } from '~/context/flp-rsc/PricingUpdateContext';
import useExpirationInfo from '~/hooks/flp-rsc/useExpirationInfo';
import { TermsProgress, TermsProgressHeading } from './TermsCard.styles';
import Timer from './Timer';
import { TimerContainer } from './Timer.styles';

type OwnProps = {
  expiration: string;
};

export default function ExpirationTimer({ expiration }: OwnProps) {
  const { daysRemaining, isLoading, isValidExpiration, percentage } =
    useExpirationInfo(expiration);
  const { isPending: isPricingPending } = usePricingUpdate();
  const { isPending: isCreditApplicationPending } =
    useCreditApplicationUpdate();

  if (isLoading || isPricingPending || isCreditApplicationPending) {
    return (
      <TimerContainer>
        <Skeleton className="h-80! w-80! rounded-full sm:h-[120px]! sm:w-[120px]!" />
      </TimerContainer>
    );
  }

  if (!isValidExpiration || !daysRemaining || daysRemaining <= 0) {
    return null;
  }

  return (
    <Timer percentage={percentage!}>
      <TermsProgress>
        <TermsProgressHeading data-testid="days-remaining">
          {daysRemaining}
        </TermsProgressHeading>
        <p>days</p>
      </TermsProgress>
    </Timer>
  );
}
